module.exports = __webpack_public_path__ + "static/gem-visa-aa58727ec428a67ee0765c1923746bb5.png";